import './instagram_message.js.coffee'
Namespace 'Models'

class Models.InstagramMessageText extends Models.InstagramMessage
  constructor: (builder) ->
    super(builder)
    @messageText = builder.messageText

  accepts: (visitor) ->
    visitor.visit_instagram_message_text(@)

  getType: ->
    'text'
